<template>
	<div>
		<el-card>
			<el-form ref="form" :model="form" label-width="80px">
				<el-form-item label="标题" prop="title">
					<el-input v-model="form.title"></el-input>
				</el-form-item>
				<el-form-item label="价格" prop="price">
					<el-input type="number" v-model="form.price"></el-input>
				</el-form-item>
				<el-form-item label="单位" prop="price">
					<el-select v-model="form.unit" placeholder="请选择">
						<el-option v-for="item in options" :key="item.value" :label="item.value" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="分类">
					<el-select v-model="goodsClassName" placeholder="请选择" @change="goodsClassChange">
						<el-option v-for="item in goodsClassList" :key="item.class_id" :label="item.class_name" :value="item.class_id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="封面">
					<el-upload ref="uUpload" class="avatar-uploader" :headers="headers" :action="action" :on-success="uploadSuccess">
						<img v-if="form.cover_img" :src="form.cover_img" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
				<el-form-item label="相册">
					<el-upload ref="uUpload" :multiple="true" :headers="headers" class="avatar-uploader" list-type="picture-card"
					 :action="action" :on-success="uploadAlbum" :on-remove="onRemove">
						<i class="el-icon-plus"></i>
					</el-upload>
				</el-form-item>
				<el-form-item label="商品详情">
					<editor-bar @change="change" v-model="form.introduce"></editor-bar>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" :loading="btnLoading" :disabled="btnDisabled" @click="onSubmit">提交</el-button>
				</el-form-item>
			</el-form>
		</el-card>
	</div>
</template>

<script>
	import EditorBar from '../../components/wangeditor/index.vue';
	export default {
		components: {
			EditorBar
		},
		data() {
			return {
				action: this.$H.domain + "common/uploadFile",
				headers: {
					token: this.$store.state.userInfo.token
				},
				form: {
					title: '',
					price: '',
					cover_img: '',
					introduce: '',
					class_id: "",
					album: [],
					unit: ""
				},
				btnLoading: false,
				btnDisabled: false,
				goodsClassName: "",
				goodsClassList: [],
				options: [{
						value: '斤'
					}, {
						value: '公斤'
					}, {
						value: '箱'
					}, {
						value: '个'
					}, {
						value: '件'
					},
					{
						value: '条'
					}
				]
			}
		},
		created() {
			this.getGoodsClass();
		},
		methods: {
			onSubmit() {
				this.btnLoading = true;
				this.btnDisabled = true;
				this.$H.post("goods/add", this.form).then(res => {
					if (res.code === 200) {
						this.$refs.form.resetFields();
						this.form.introduce = "";
						this.form.cover_img = "";
						this.goodsClassName = "";
						this.$refs.uUpload.clearFiles();
						this.$message.success(res.msg)
					}

					this.btnLoading = false;
					this.btnDisabled = false;
				})
			},
			onRemove(file, fileList) {
				let album = [];
				fileList.forEach((item, index) => {
					album.push(item.response.data.url)
				})
				this.form.album = album;
			},
			uploadSuccess(e) {
				this.form.cover_img = e.result.url;
			},
			uploadAlbum(e) {
				this.form.album.push(e.result.url);
			},

			getGoodsClass() {
				this.$H.get("goods/goodsClass").then(res => {
					this.goodsClassList = res.result;
				})
			},
			goodsClassChange(e) {
				this.form.class_id = e;
			},
			change(html) {
				this.form.introduce = html;
			}
		}
	}
</script>

<style>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 145px;
		height: 145px;
		line-height: 145px;
		text-align: center;
	}

	.avatar {
		width: 145px;
		height: 145px;
		display: block;
	}
</style>
